import { map } from 'rxjs';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe, NgIf } from '@angular/common';

import { GetBackendInfo } from './backend-version-info';

import { versionInfo, environment } from '@wo-environments';

@Component({
  selector: 'wo-env-info',
  templateUrl: './env-info.component.html',
  styleUrls: [ './env-info.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    NgIf,
  ],
})
export class EnvInfoComponent {
  public readonly production = environment.production;
  public readonly env$ = inject(GetBackendInfo).getInfo().pipe(map(backendInfo => {
    const fe = versionInfo.tag || versionInfo.hash;
    const be = backendInfo.git?.tags || backendInfo.git?.commit?.id;

    const FE  = fe ? `FE: ${fe}` : '';
    const BE  = be ? `BE: ${be}` : '';

    [ FE, BE ].filter(Boolean).join(', ');

    return [ environment.envName, [ FE, BE ].filter(Boolean).join(', ') ].join(' - ');
  }));

  constructor() {
    try {
      if (environment.production) {
        this.env$.subscribe(console.info);
      }
    } catch {}
  }
}
